import { useState } from 'react';
import { SiTwilio } from 'react-icons/si';
import { useAppInfo } from '../../../helpers/hooks/common-hook';
import { ChannelLayout, SettingsCard, CredentialForm, secondaryButton, useChannelStatus } from '../_components/channel-settings';
import PhoneNumbersListPage from './phone-numbers-list';

function TwilioSettings({ appId }) {
  const status = useChannelStatus(appId, 'twilio');
  const [editing, setEditing] = useState(false);
  return <ChannelLayout title="Twilio" description="Connect phone numbers and manage your agent’s SMS and voice channels." icon={SiTwilio} {...status}>
    <SettingsCard title="Twilio account" description="Manage the account credentials used for your phone numbers."
      action={status.configured && !editing && <button type="button" onClick={() => setEditing(true)} className={secondaryButton}>Update credentials</button>}>
      {!status.configured || editing ? <CredentialForm appId={appId} channel="twilio" configured={status.configured}
        fields={[{ name: 'accountSID', label: 'Account SID', placeholder: 'AC…' }, { name: 'authToken', label: 'Auth token', secret: true }]}
        serialize={values => ({ accessKey: JSON.stringify(values) })}
        onSaved={() => { status.setConfigured(true); setEditing(false); }} onCancel={status.configured ? () => setEditing(false) : undefined} />
        : <p className="text-sm text-gray-500">Account credentials are saved. Manage your connected phone numbers below.</p>}
    </SettingsCard>
    {status.configured ? <PhoneNumbersListPage /> : <div className="rounded-2xl border border-dashed border-gray-200 p-8 text-center"><h2 className="text-sm font-semibold text-gray-800">Connect your account first</h2><p className="mt-2 text-sm text-gray-500">Once credentials are saved, you can choose the phone numbers to connect to this agent.</p></div>}
  </ChannelLayout>;
}
export default function TwilioPage() {
  const { appId } = useAppInfo();
  return <TwilioSettings key={appId} appId={appId} />;
}
